<template>
  <section>
    <h1 class="text-h3 mb-8">
      Text fields
    </h1>
    <v-container>
      <v-row
        v-for="i in 2"
        :key="i"
      >
        <v-col>
          <v-text-field
            v-model="value[i]"
            :label="(i === 1 ? 'Filled' : 'Outlined') + ' text field'"
            :filled="i === 1"
            :outlined="i === 2"
            hint="A hint for the text field."
            persistent-hint
            clearable
          />
        </v-col>
        <v-col>
          <v-text-field
            v-model="value[i]"
            :label="(i === 1 ? 'Filled' : 'Outlined') + ' text field'"
            :filled="i === 1"
            :outlined="i === 2"
            error-messages="A error message for the text field."
            error
            clearable
          />
        </v-col>
        <v-col>
          <v-text-field
            v-model="value[i]"
            :label="(i === 1 ? 'Filled' : 'Outlined') + ' text field'"
            :filled="i === 1"
            :outlined="i === 2"
            hint="A hint for the text field."
            persistent-hint
            clearable
            disabled
          />
        </v-col>
      </v-row>
    </v-container>
    <h2 class="text-h4 mb-4">
      Further reading
    </h2>
    <external-link href="https://vuetifyjs.com/en/components/text-fields/">
      <strong>Text fields</strong>
    </external-link>
  </section>
</template>

<script>
export default {
  name: 'FormTextFields',
  data: () => ({
    value: {
      1: '',
      2: ''
    }
  })
}
</script>
